
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Uid"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingFlow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flowId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vertical"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"bunches"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transit"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"landing"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebookPixel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookPixelFieldName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookPixelCustomLeadEvent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookPixelCustomPageViewEvent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"googleAnalytic"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"googleAnalyticFieldName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yandexMetrica"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yandexMetricaFieldName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tiktokPixel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tiktokPixelFieldName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"webmasterDomain"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"domonetization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"domonetizationType"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":851}};
    doc.loc.source = {"body":"# noinspection GraphQLUnresolvedReference\nquery ($flowId: Uid!) {\n    landingFlow (flowId: $flowId) {\n        name\n        offer {\n            id\n            vertical\n        }\n        bunches {\n            transit {\n                name\n                id\n                link\n            }\n            landing {\n                name\n                id\n                link\n            }\n        }\n        options {\n            facebookPixel\n            facebookPixelFieldName\n\n            facebookPixelCustomLeadEvent\n            facebookPixelCustomPageViewEvent\n            googleAnalytic\n            googleAnalyticFieldName\n            yandexMetrica\n            yandexMetricaFieldName\n            tiktokPixel\n            tiktokPixelFieldName\n            webmasterDomain\n            domonetization\n            domonetizationType\n        }\n    }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
